import { z } from 'zod';

export const denyDeviceAuthorizationSchema = z.object({
  device_authorization_id: z.uuid('Valid device authorization ID is required'),
});

export type DenyDeviceAuthorizationPayload = z.infer<typeof denyDeviceAuthorizationSchema>;
